module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    on: {
      "click": _vm.show
    }
  }, [_vm._v(_vm._s(_vm.uid))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.show
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "学生个人信息"
    },
    model: {
      value: (_vm.modal),
      callback: function($$v) {
        _vm.modal = $$v
      },
      expression: "modal"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "label-width": 80
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生头像:",
      "prop": "avatarUrl"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.openStudentPage
    }
  }, [(_vm.student.avatarUrl) ? _c('img', {
    attrs: {
      "src": _vm.student.avatarUrl,
      "alt": "",
      "width": "40px"
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/defaultAvatar.jpeg",
      "alt": "",
      "width": "40px"
    }
  })])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名:",
      "prop": "nickname"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.student.nickname) + "\n          ")])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "手机号:",
      "prop": "mobile"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.student.mobile) + "\n          ")])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "性别:",
      "prop": "sex"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.student.stringSex) + "\n          ")])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "生日:",
      "prop": "birthday"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.student.stringBirthday) + "\n          ")])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学校:",
      "prop": "school"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.student.school) + "\n          ")])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "邮箱:",
      "prop": "email"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.student.email) + "\n          ")])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "qq:",
      "prop": "qq"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.student.qq) + "\n          ")])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "所在地区:",
      "prop": "province"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.student.province) + _vm._s(_vm.student.city) + _vm._s(_vm.student.zone) + "\n          ")])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "地址:",
      "prop": "address"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.student.address) + "\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.modal = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e0932e8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/StudentInfo.vue
// module id = 1834
// module chunks = 8